import {combineReducers} from "redux";

import listeCoursSpecialsReducer from "./listeCoursSpecials";
import listeCategoriesSpecialsReducer from "./listeCategoriesSpecials";


export default combineReducers({
    listeCoursSpecials : listeCoursSpecialsReducer,
    listeCategoriesSpecials: listeCategoriesSpecialsReducer
});